import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { SystemService } from '@shared/service/system/system.service';
import { AuthService } from '../auth/service/auth.service';
import { filter, firstValueFrom, take } from 'rxjs';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class DictionariesViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);

  private systemService = inject(SystemService); // not sure why i need this ?
  private authService = inject(AuthService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    await firstValueFrom(
      this.systemService.isInitialized$.pipe(
        filter((val) => val),
        take(1),
      ),
    );

    const routeUrl = this.routeGuardService.getRouteUrl(route);
    const hasPermission = this.authService.getRoutePermissions(routeUrl);
    if (!hasPermission) {
      return false;
    }

    this.routeGuardService.handleRoute(this.getView());
    return true;
  }

  getView(): View {
    return {
      route: 'dictionaries',
      iframeUrl: 'dictionaries',
    };
  }
}
